import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

import { Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

import { RangeConfig, CalendarConfig, RangePickerService } from '../../utils';

@Component({
    selector: '[aaNavigation]',
    templateUrl: './navigation.component.html',
    styleUrls: [
        '../shared.scss',
        './navigation.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavigationComponent implements OnInit, OnDestroy
{
    private destroyator = new Subject();
    @Input() config: RangeConfig;
    @Output() fromNavigationShowMonths: EventEmitter<null> = new EventEmitter<null>();
    @Output() fromNavigationShowYears: EventEmitter<null> = new EventEmitter<null>();
    public cfg: CalendarConfig = new CalendarConfig();
    public displayRange: string = '';

    constructor(private rangePickerService: RangePickerService)
    {
    }

    ngOnInit ()
    {
        this.rangePickerService.config
            .pipe(
                tap((rc: RangeConfig) =>
                    this.formatDate(rc)
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    onShowMonths ()
    {
        this.fromNavigationShowMonths.emit();
    }

    onShowYears ()
    {
        this.fromNavigationShowYears.emit();
    }

    onPrevYear ()
    {
        this.rangePickerService.prevYear();
    }

    onPrevMonth ()
    {
        this.rangePickerService.prevMonth();
    }

    onNextMonth ()
    {
        this.rangePickerService.nextMonth();
    }

    onNextYear ()
    {
        this.rangePickerService.nextYear();
    }

    private formatDate (rc: RangeConfig)
    {
        const displayLeft = rc.leftFirstDay.toFormat('LLL yyyy');
        const displayRight = rc.rightFirstDay.toFormat('LLL yyyy');

        this.displayRange = `${displayLeft} - ${displayRight}`;
    }
}
